const InputField = ({
  id,
  label,
  type = "text",
  name,
  value,
  onChange,
  error,
  placeholder,
  required = false,
  options = null, // nếu là select
  textarea = false,
  className = "",
}) => {
  return (
    <div className={`registration-form__field ${className}`}>
      <label
        htmlFor={id}
        className="registration-form__label"
      >
        {label} {required && <span className="required">*</span>}
      </label>
      {textarea ? (
        <textarea
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className="registration-form__textarea"
          placeholder={placeholder}
        />
      ) : options ? (
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className="registration-form__select"
        >
          {options.map((opt) => (
            <option
              key={opt.value}
              value={opt.value}
            >
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className="registration-form__input"
          placeholder={placeholder}
        />
      )}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default InputField;
